import React from 'react';
import { ShoppingCart, Trash2 } from 'lucide-react';
interface CartDropdownProps {
  items: any[];
  removeItem: (id: string) => void;
  formatPrice: (p: number) => string;
  cartTotal: number;
  onNavigate: (page: string) => void;
  setIsCartOpen: (isOpen: boolean) => void;
}
export function CartDropdown({
  items,
  removeItem,
  formatPrice,
  cartTotal,
  onNavigate,
  setIsCartOpen
}: CartDropdownProps) {
  return <div className="absolute top-full right-0 mt-1.5 w-80 rounded-xl shadow-xl bg-white ring-1 ring-slate-900/5 z-50 overflow-hidden" data-id="element-16309">
      <div className="px-4 pt-3 pb-2 border-b border-slate-100 flex items-center justify-between" data-id="element-16310">
        <span className="text-sm font-bold text-slate-900" data-id="element-16311">Корзина</span>
        {items.length > 0 && <span className="text-xs text-slate-400" data-id="element-16312">
            {items.length}{' '}
            {items.length === 1 ? 'товар' : items.length < 5 ? 'товара' : 'товаров'}
          </span>}
      </div>
      {items.length > 0 ? <>
          <div className="max-h-64 overflow-y-auto p-2 space-y-1.5" data-id="element-16313">
            {items.map(item => <div key={item.id} className="flex items-center gap-3 p-2.5 rounded-lg bg-slate-50 group" data-id="element-16314">
                <div className="w-2 h-2 rounded-full bg-indigo-400 flex-shrink-0" data-id="element-16315" />
                <div className="flex-1 min-w-0" data-id="element-16316">
                  <div className="text-sm font-medium text-slate-900 truncate" data-id="element-16317">
                    {item.name}
                  </div>
                  {item.badges?.[0] && <span className="text-[10px] text-slate-400" data-id="element-16318">
                      {item.badges[0].label}
                    </span>}
                </div>
                <span className="text-sm font-bold text-slate-900 tabular-nums whitespace-nowrap" data-id="element-16319">
                  {formatPrice(item.price)}
                </span>
                <button onClick={e => {
            e.stopPropagation();
            removeItem(item.id);
          }} className="w-6 h-6 rounded-full flex items-center justify-center text-slate-300 hover:text-red-500 hover:bg-red-50 transition-colors opacity-0 group-hover:opacity-100" aria-label="Удалить" data-id="element-16320">
                  <Trash2 className="w-3 h-3" data-id="element-16321" />
                </button>
              </div>)}
          </div>
          <div className="px-4 py-3 border-t border-slate-100" data-id="element-16322">
            <div className="flex items-center justify-between mb-3" data-id="element-16323">
              <span className="text-sm text-slate-500" data-id="element-16324">Итого</span>
              <span className="text-base font-bold text-slate-900 tabular-nums" data-id="element-16325">
                {formatPrice(cartTotal)}
              </span>
            </div>
            <button onClick={() => {
          setIsCartOpen(false);
          onNavigate('checkout');
        }} className="w-full py-2.5 px-4 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700 transition-colors" data-id="element-16326">
              Оформить заказ
            </button>
          </div>
        </> : <div className="py-8 text-center" data-id="element-16327">
          <ShoppingCart className="w-8 h-8 text-slate-200 mx-auto mb-2" data-id="element-16328" />
          <p className="text-sm text-slate-400" data-id="element-16329">Корзина пуста</p>
          <button onClick={() => {
        setIsCartOpen(false);
        onNavigate('marketplace');
      }} className="text-xs text-indigo-600 hover:underline mt-2 inline-block" data-id="element-16330">
            Перейти в маркетплейс
          </button>
        </div>}
    </div>;
}